import {
  mapLocaleAliasToSupportedLocale,
  SupportedLocale,
} from '@/utils/i18n/supportedLocales';

const INTERCOM_DISABLED_LOCALES = new Set<string>([SupportedLocale.JaJp.toLowerCase()]);

export const isIntercomDisabledForLocale = (locale?: string | null): boolean => {
  if (!locale) return false;

  const canonicalLocale = mapLocaleAliasToSupportedLocale(locale);
  if (!canonicalLocale) return false;

  return INTERCOM_DISABLED_LOCALES.has(canonicalLocale.toLowerCase());
};
